import axios from 'axios';

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Ralat. Sila cuba lagi.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || '').filter(Boolean).join(' ');
  return String(detail?.msg || detail);
}

export function bearerAuthConfig() {
  const token = localStorage.getItem('pp_token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}
